<template>
  <div>
    <TopHeader code="know" />

    <section class="container-fluid uc-bg2">
      <div class="container">
        <div class="row">
          <div class="col-24">
            <div class="uc-crumb">
              <router-link to="/" class="item">首页</router-link>
              <router-link :to="{ name: 'UserKnowledge' }" class="item"
                >知识库</router-link
              >
              <router-link to="" class="item">知识详情</router-link>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="container-fluid uc-bg2 uc-pb40">
      <div class="container">
        <div class="row">
          <div class="col-24 col-sm-24">
            <section class="uc-ResourcesDetail uc-mr10" ref="waterContent">
              <div
                v-if="this.$utils.matchType(iframeContentUrl) === 'video'"
                style="height: calc(100vh - 120px)"
              >
                <VideoPlayer ref="cVideo"></VideoPlayer>
              </div>
              <div
                v-else-if="this.$utils.matchType(iframeContentUrl) === 'image'"
                class="img-box"
              >
                <el-image :src="model.url">
                  <div slot="error" class="image-slot">
                    <img src="../../assets/images/default-kc.png" />
                  </div>
                </el-image>
              </div>
              <div
                v-else-if="this.$utils.matchType(iframeContentUrl) === 'pdf'"
              >
                <iframe
                  :src="`${adminUrl}/pdf/web/viewer.html?file=${model.url}`"
                  style="width:100%;height:860px;"
                  allowfullscreen="true"
                  frameborder="0"
                />
              </div>
            </section>
          </div>
        </div>
      </div>
    </section>

    <BottomFooter />
  </div>
</template>

<script>
import TopHeader from '@/components/TopHeader.vue';
import BottomFooter from '@/components/BottomFooter.vue';
import watermark from '@/utils/watermark.js';
import VideoPlayer from '@/components/VideoPlayer.vue';

export default {
  name: 'UserKnowledgeDetails',
  components: {
    TopHeader,
    BottomFooter,
    VideoPlayer,
  },
  data() {
    return {
      adminUrl: process.env.VUE_APP_ADMINURL,
      query: { id: this.$route.params.id },
      model: {},
      myEvaluationScore: 0,
      list: {},
      iframeContentUrl: '',
      // 收藏相关--begin
      isStorage: false,
      innerVisible: false,
      outerVisible: false,
      radio: '',
      templateSelection: {},
      form: {
        id: 0,
        name: '',
        description: '',
        url: '',
      },
      formLabelWidth: '60px',
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
      },
      // 收藏相关--end
    };
  },
  created() {
    this.loadData();
  },
  watch: {
    $route(to, from) {
      // 对路由变化作出响应...
      this.query.id = to.params.id;
      this.loadData();
    },
  },
  methods: {
    loadData() {
      this.getUserKnowledgeDetails();
    },
    // 点击收藏按钮
    btnStorage() {
      // this.isStorage = !this.isStorage;
      // console.log(this.isStorage);
      if (!this.isStorage) {
        this.outerVisible = true;
        this.getFavoritesTree();
      } else {
        const submitData = {
          tenant_id: this.query.id,
          tenant_type: 'UserKnowledge',
          is_collected: !this.isStorage,
        };
        // 取消收藏
        this.cancelToFavorites(submitData);
      }
    },
    // 创建文件夹
    handleCreateFavoritesSure() {
      const submitData = {
        id: this.form.id,
        name: this.form.name,
        description: this.form.description,
      };
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 请求
          // console.log(submitData);
          this.postFavorites(submitData);
        }
      });
    },
    // 关闭窗口：点击取消
    handleCloseFavorites() {
      this.innerVisible = false;
      // 点击取消按钮的时候清除输入框中的内容 清除验证
      //  this.$nextTick获取了节点之后进行操作
      this.$nextTick(() => {
        // form对应你写的<el-form ref="form"></el-form>
        this.$refs.form.resetFields();
      });
    },
    // 关闭窗口：点击X
    handleCloseDialog() {
      this.$refs.form.resetFields();
    },
    // 获取选中行：收藏夹
    getTemplateRow(index, row) {
      this.templateSelection = row;
    },
    // 点击行选中
    handleCurrentChange(row) {
      // 如果没有row,终止
      if (!row) {
        return;
      }
      // 把当前行label绑定的值和v-model绑定的值相同时,单选按钮就可以选中
      this.radio = row.row;
      this.templateSelection = row;
    },

    async getUserKnowledgeDetails() {
      const response = await this.$api.userknowledge.getUserKnowledgeDetails(
        this.query
      );
      this.model = response.data.data;
      this.iframeContentUrl = this.model.url;

      this.videoPlay();
    },
    async videoPlay() {
      this.$nextTick(() => {
        if (this.$utils.matchType(this.iframeContentUrl) === 'video') {
          const cOptions = this.$refs.cVideo.options;

          this.$set(cOptions.sources, 0, {
            type: 'video/mp4',
            src: this.iframeContentUrl,
            //src: "https://view.2amok.com/2019716/b3b8fb0d964323e7e018ac1a426272b6.mp4",
          });
        }
      });
    },
  },
  mounted() {
    watermark.set(
      this.$store.getters.user.first_name +
        ' ' +
        this.$store.getters.user.username,
      this.$moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
      this.$refs.waterContent
    );
  },
};
</script>
